require("whatwg-fetch"); // Global

const Path = require("path");

const RootURL = require("./Config.js").RootApiUrl;
/*const Authenticator = require("./Authenticator.js");*/
const msal = require("./MsalApi.js");

const AuthenticationActions = require("./actions/AuthenticationActions.js");
const Dispatch = require("./store.js").dispatch;

const Server = {
    Get(url) {

        let fullUrl = toFullUrl(url);

        let promise = getPromiseForFetchWithToken((token) => {
            let config = {
                headers: getDefaultHeaders(token)
            };

            return fetch(fullUrl, config);
        });

        return promise;
    },
    PostFiles(url, files, metadata) {
        let fullUrl = toFullUrl(url);

        let form = getUploadFormData(files, metadata);

        let promise = getPromiseForFetchWithToken((token) => {
            let config = {
                method: "POST",
                headers: getDefaultHeaders(token),
                body: form
            };

            return fetch(fullUrl, config);
        });

        return promise;
    }
};

module.exports = Server;

// Tricky:
/**
 * @param {tokenConsumingFetch} - a function that accepts
 *  an OAuth token, and returns a whatwg-fetch promise.
 */
function getPromiseForFetchWithToken(tokenConsumingFetch) {
    function resolver(resolve, reject) {

        msal.getToken(function (token) {

            tokenConsumingFetch(token)
                .then(checkForError)
                // Resolve the promise only if there's a
                // response at this point.  (If there's
                // not, there must have been an error,
                // so .catch will be called, below.)
                .then((response) => {
                    if (response) resolve(response);
                })
                .catch(reject);
        });
    }

    var promise = new Promise(resolver);  

    return promise;
}

function getDefaultHeaders(token) {
    return {
        Authorization: "Bearer " + token
    };
}

function toFullUrl(path) {
    return Path.join(RootURL, path).replace(":/", "://");
}

function checkForError(response) {
    if (response.status >= 300) {
        if (response.status === 401 || response.status === 403) {
            showUnauthorized(response);
        }

        var error = new Error(response.statusText);
        error.response = response;

        throw error;
    }
    else {
        return response;
    }
}

function showUnauthorized(response) {
    var actionType =
        response.status === 401
            ? "Unauthorized"
            : "Unauthenticated";

    Dispatch({
        type: AuthenticationActions[actionType],
        Response: response
    });
}

function getUploadFormData(files, metadata) {
    let formData = new FormData();

    if ((files || []).length) {
        for (var i = 0; i < files.length; i++) {
            // Not ideal, but it's a far edge case -- no need to pollute our
            // validation with something like this.
            if (files[i.name] === "metadata") {
                throw new Error("Files named \"metadata\" are not allowed.");
            }

            formData.append(files[i].name, files[i]);
        }
    }

    if (metadata) {
        formData.append("metadata", metadata);
    }

    return formData;
}


// WEBPACK FOOTER //
// ./src/Server.js